import React from 'react';
import Header from '../components/Header/Header';
import Navbar from '../components/Navbar/Navbar';
import Committee from '../components/Committee/Committee';
import avatar from "../components/assets/avatar.png";
import l1 from "../components/assets/l1.png";
import l2 from "../components/assets/l2.png";
import l3 from "../components/assets/l3.png";
import l4 from "../components/assets/l4.png";
import l5 from "../components/assets/l5.png";
import l6 from "../components/assets/l6.png";
import l7 from "../components/assets/l7.png";
import l8 from "../components/assets/l8.png";
import l9 from "../components/assets/l9.png";
import l10 from "../components/assets/l10.png";
import l11 from "../components/assets/l11.png";
import l12 from "../components/assets/l12.png";
import l13 from "../components/assets/l13.png";


const LocalAdvisory = () => {
    const committeeMembers = [
        {
            name: "Prof. Vatsala Mishra",
            role: "Department. of Pathology & Transfusion Medicine",
            designation: "Motilal Nehru Medical College, Prayagraj",
            imageUrl: l1,
        },
        {
            name: "Prof. Tariq Mehmood",
            role: "Department of Pulmonary Medicine",
            designation: "Motilal Nehru Medical College, Prayagraj",
            imageUrl: l2,
        },
        {
            name: "Prof. R. P. Tewari",
            role: "Department of Applied Mechanics",
            designation: "MNNIT Allahabad",
            imageUrl: l3,
        },
        {
            name: "Prof. Abhay Pandey",
            role: "Department of Biochemistry",
            designation: "University of Allahabad",
            imageUrl: l4,
        },
        {
            name: "Prof. Shanti Sundaram",
            role: "Department of Biotechnology",
            designation: "University of Allahabad",
            imageUrl: l5,
        },
        {
            name: "Prof. Bechan Sharma",
            role: "Department of Biotechnology",
            designation: "University of Allahabad",
            imageUrl: l6,
        },
        {
            name: "Dr. Sonia Tiwari",
            role: "Kamla Nehru Memorial Hospital",
            designation: "Prayagraj",
            imageUrl: l7,
        },
        {
            name: "Prof. Mayank Pandey",
            role: "Department of Computer Science",
            designation: "MNNIT Allahabad",
            imageUrl: l8,
        },
        {
            name: "Prof. Naresh Kumar",
            role: "Department of Physics",
            designation: "MNNIT Allahabad",
            imageUrl: l9,
        },
        {
            name: "Prof. Basant Kumar",
            role: "Department of Electronics and communication Engineering",
            designation: "MNNIT Allahabad",
            imageUrl: l10,
        },
        {
            name: "Prof. Sushil Kumar",
            role: "Department of Chemical Engineering",
            designation: "MNNIT Allahabad",
            imageUrl: l11,
        },
        {
            name: "Dr. Ramji Dwivedi",
            role: "GIS cell",
            designation: "MNNIT Allahabad",
            imageUrl: l12,
        },{
            name: "Dr. Kewat Sanjay Kumar",
            role: "Department of Botany",
            designation: "University of Allahabad ",
            imageUrl: l13,
        },
    ];

    return (
        <div>
            <Header />
            <Navbar />
            <Committee heading="Local Advisory Committee" people={committeeMembers} />
        </div>
    );
};

export default LocalAdvisory;
